import React from 'react';

const Breadcrumb = props => (
    <div className="breadcrumb-bar">
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col-md-8 col-12">
                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">{props.subtitle != undefined ? props.subtitle : props.title}</li>
                        </ol>
                    </nav>
                    <h2 className="breadcrumb-title"> {props.title} </h2>
                </div>
                {
                    props.children != undefined && 
                    <div className="col-md-4 col-12 d-md-block d-none">
							{props.children}
					</div>
                }
            </div>
        </div>
    </div>
);
export default Breadcrumb;